module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/5_1-f10185220cf207190036ae47c5cd1457.png";